var _path, _path2, _path3, _path4, _path5, _path6, _animateTransform;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenaiIconLoading({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#392D69",
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    id: "openai",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,16.14l14.72-8.5c0.01,0,0.01-0.01,0.02-0.01c-0.58-1.16-1.34-2.21-2.25-3.12C34.32,2.34,31.32,1,28,1  c-6.62,0-11.99,5.36-12,11.98c0,0.01,0,0.01,0,0.02v17l7.97,4.62L24,16.14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.546,36.356l14.722,8.5l7.986-4.592l-15.989-9.266L14.264,14c0.005-0.009-0.004-0.014,0.001-0.022  c-1.295-0.078-2.584,0.055-3.827,0.389c-2.964,0.794-5.625,2.722-7.285,5.598c-3.31,5.733-1.353,13.064,4.375,16.382  C7.537,36.351,7.537,36.351,7.546,36.356z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.284,37.644l-16.019,9.214L7.544,38.36c-0.005-0.009-0.014-0.004-0.019-0.012c-0.715,1.082-1.244,2.266-1.577,3.509  c-0.794,2.964-0.455,6.232,1.205,9.108c3.31,5.733,10.637,7.704,16.375,4.402c0.009-0.005,0.009-0.005,0.017-0.01l14.722-8.5  L38.284,37.644z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40,47.86l-14.72,8.5c-0.01,0-0.01,0.01-0.02,0.01c0.58,1.16,1.34,2.21,2.25,3.12C29.68,61.66,32.68,63,36,63  c6.62,0,11.99-5.36,12-11.98c0-0.01,0-0.01,0-0.02V34l-7.97-4.62L40,47.86z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.472,27.654c-0.009-0.005-0.009-0.005-0.017-0.01l-14.722-8.5l-7.986,4.592l15.989,9.266L49.736,50  c-0.005,0.009,0.004,0.014-0.001,0.022c1.295,0.078,2.584-0.055,3.827-0.389c2.964-0.794,5.625-2.722,7.285-5.598  C64.157,38.303,62.2,30.972,56.472,27.654z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.456,25.64c0.005,0.009,0.014,0.004,0.019,0.012c0.715-1.082,1.244-2.265,1.577-3.509  c0.794-2.964,0.455-6.232-1.205-9.108c-3.31-5.733-10.637-7.704-16.375-4.402c-0.009,0.005-0.009,0.005-0.017,0.01l-14.722,8.5  l-0.016,9.212l16.019-9.214L56.456,25.64z"
  })), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    dur: "2s",
    values: "0 0 0;360 0 0;",
    repeatCount: "indefinite"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenaiIconLoading);
export default __webpack_public_path__ + "static/media/openai-icon-loading.40bc0cb4fd8fbf8ba02bc8e190e81f16.svg";
export { ForwardRef as ReactComponent };